import * as types from 'manuals/actions/types';
import {apiAction} from 'apa/actions';
import {deselectCategory} from 'manuals/actions/category';
import {ENDPOINT_MANUAL_CATEGORY_URL, ENDPOINT_MANUAL_URL} from 'manuals/actions/index';

export const loadManualList = (category) => dispatch => {
    dispatch({type: types.LOAD_MANUAL_LIST})
    dispatch(apiAction({
        url: `${ENDPOINT_MANUAL_CATEGORY_URL}${category.id}/manuals/`,
        onSuccess: templateList => ({
            type: types.LOAD_MANUAL_LIST_SUCCESS,
            selectedCategory: category,
            manualList: templateList
        }),
        onFailure: errors => ({
            type: types.LOAD_MANUAL_LIST_ERROR,
            errors: errors
        })
    }))
}
export const searchManual = (searchText) => dispatch => {
    if (searchText === '') {
        dispatch({type: types.SEARCH_MANUAL_LIST_RESET})
    } else {
        dispatch({type: types.SEARCH_MANUAL_LIST})
        dispatch(deselectManual())
        dispatch(deselectCategory())
        dispatch(apiAction({
            url: `${ENDPOINT_MANUAL_URL}?search=${searchText}`,
            onSuccess: templateList => ({
                type: types.SEARCH_MANUAL_LIST_SUCCESS,
                manualList: templateList
            }),
            onFailure: errors => ({
                type: types.SEARCH_MANUAL_LIST_ERROR,
                errors: errors
            })
        }))
    }
}
export const selectManual = (manual) => dispatch =>
    dispatch({type: types.SELECT_MANUAL, manual: manual})
export const deselectManual = () => dispatch =>
    dispatch({type: types.DESELECT_MANUAL})
export const createManual = (data) => (dispatch, getState) => {
    const manuals = getState().manuals
    dispatch({type: types.CREATE_MANUAL})
    dispatch(apiAction({
        url: ENDPOINT_MANUAL_URL,
        method: 'POST',
        data: data,
        onSuccess: manual => {
            const firstCategoryId = manual.category[0];
            const firstCategory = manuals.categoryList.filter(
                category => category.id === firstCategoryId
            )[0]
            dispatch(loadManualList(firstCategory))
            dispatch(selectManual(manual))
            return {
                type: types.CREATE_MANUAL_SUCCESS,
                template: manual
            }
        },
        onFailure: errors => ({
            type: types.CREATE_MANUAL_ERROR,
            errors: errors
        })
    }))
}
export const updateManual = (manual) => dispatch =>
    dispatch({type: types.UPDATE_MANUAL, template: manual})
export const uploadManualFile = (manualId, data, onSuccess = () => {
}, onError = () => {
}) => dispatch => {
    dispatch({type: types.UPLOAD_MANUAL_FILE})
    dispatch(apiAction({
        url: `${ENDPOINT_MANUAL_URL}${manualId}/`,
        method: 'PATCH',
        data: data,
        onSuccess: template => {
            dispatch(selectManual(template))
            onSuccess()
            return {
                type: types.UPLOAD_MANUAL_FILE_SUCCESS
            }
        },
        onFailure: errors => {
            onError()
            return {
                type: types.UPLOAD_MANUAL_FILE_ERROR,
                errors: errors
            }
        }
    }))
}
export const saveManual = (manual) => (dispatch, getState) => {
    const newManual = {...manual}
    delete newManual.filename
    delete newManual.file_exists
    dispatch(apiAction({
        url: `${ENDPOINT_MANUAL_URL}${newManual.id}/`,
        method: 'PATCH',
        data: newManual,
        onSuccess: newManual => {
            const newManualList = getState().manuals.manualList.map(
                obj => obj.id === newManual.id ? newManual : obj
            )
            return {
                type: types.SAVE_MANUAL_SUCCESS,
                manualList: newManualList
            }
        },
        onFailure: errors => ({
            type: types.SAVE_MANUAL_ERROR,
            errors: errors
        })
    }))
}
export const deleteManual = manual => (dispatch, getState) => {
    dispatch({type: types.DELETE_MANUAL})
    const state = getState()
    const selectedCategory = state.manuals.selectedCategory
    dispatch(apiAction({
            url: `${ENDPOINT_MANUAL_URL}${manual.id}/`,
            method: 'DELETE',
            onSuccess: () => {
                dispatch(deselectManual())
                dispatch(loadManualList(selectedCategory))
                return {
                    type: types.DELETE_MANUAL_SUCCESS
                }
            },
            onFailure: errors => ({
                type: types.DELETE_MANUAL_ERROR,
                errors: errors
            })
        })
    )
}
